<template>
  <div class="site-box" @click="click">
    <div class="site-picture" :style="{ 'background-image': `url('${data.image}')` }"></div>
    <div class="details">
      <span class="title"> <span class="poi" :style="{ 'background-image': `url('${data.poi}')` }"></span> {{ data.name }} </span>
      <span class="address">{{ data.address }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['idx', 'data', 'action'],

  data: function () {
    return {
      // eslint-disable-next-line no-empty-function
      click: this.action || function () {},
    };
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';
.site-box {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  .current-site-picture {
    width: 30%;
    margin-left: 10px;
    margin-right: 10px;
  }
  .site-picture {
    height: 80%;
    width: 30%;
    flex-shrink: 0;
    display: block;
    margin-left: 10px;
    margin-right: 10px;
    border-radius: 5px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
  }
  .details {
    flex: 1;
    .title {
      display: flex;
      align-items: center;
      font-weight: 900;
      font-size: 12px;
    }
    .poi {
      width: 24px;
      height: auto;
      display: inline-block;
      margin-right: 0.15em;
      height: 26px;
      background-size: contain;
      margin-bottom: -10px;
      margin-top: -10px;
      margin-left: -5px;
      background-repeat: no-repeat;
      text-align: center;
      color: white;
    }
    .address {
      font-size: 11px;
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 160px;
    }
  }
}
</style>
